export default "__VITE_ASSET__ScEDUULW__"